export interface UrlProvider {
  getUrl(): string;
  refreshUrl(): Promise<void>;
}

/**
 * Create URL provider for static URLs that can not be refreshed
 */
export function makeStaticUrlProvider(url: string): UrlProvider {
  return {
    getUrl: () => url,
    refreshUrl: async () => { },
  };
}
